var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-menu',{key:"user-menu",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"text--secondary px-0 px-md-2 btn-menu",attrs:{"text":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("fas fa-user-circle")]),_c('app-chevron-down')],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }